import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconSvgComponent } from '../icon/icon.component';

@Component({
  standalone: true,
  selector: 'rx-form-field',
  templateUrl: './form-field-view-mode.component.html',
  styleUrls: ['./form-field-view-mode.component.scss'],

  imports: [CommonModule, IconSvgComponent],
})
export class FormFieldViewModeComponent {
  @Input() label: string;
  @Input() secondaryLabel?: string;
  @Input() value: string | number | boolean = '';

  isBoolean(value: string | number | boolean): boolean {
    return typeof value === 'boolean';
  }
}
